module.exports = __webpack_public_path__ + "img/9.a0845ef2.png";